import { Minus, X, ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { PanelState } from '@/types/communication-panels';

interface PanelHeaderProps {
  title: string;
  icon: React.ReactNode;
  state: PanelState;
  onMinimize: () => void;
  onClose: () => void;
  onRestore: () => void;
  onPopOut?: () => void;
  showNotificationBadge?: boolean;
}

export function PanelHeader({
  title,
  icon,
  state,
  onMinimize,
  onClose,
  onRestore,
  onPopOut,
  showNotificationBadge,
}: PanelHeaderProps) {
  if (state === 'closed') return null;

  const isMinimized = state === 'minimized';

  return (
    <div
      onClick={isMinimized ? onRestore : undefined}
      className={cn(
        "flex items-center justify-between px-3 border-b border-border bg-muted/50 select-none",
        isMinimized ? "h-10 cursor-pointer hover:bg-muted/80" : "h-10",
        "transition-colors duration-150"
      )}
    >
      <div className="flex items-center gap-2 min-w-0">
        <span className="text-muted-foreground shrink-0">{icon}</span>
        <span className="text-sm font-medium text-foreground truncate">{title}</span>
        {showNotificationBadge && (
          <span className="w-2.5 h-2.5 rounded-full bg-destructive animate-pulse shrink-0" />
        )}
      </div>
      <div className="flex items-center gap-0.5 shrink-0">
        {!isMinimized && onPopOut && (
          <button
            onClick={(e) => { e.stopPropagation(); onPopOut(); }}
            className="w-7 h-7 rounded hover:bg-secondary flex items-center justify-center"
            title="Pop ud"
          >
            <ExternalLink className="w-3.5 h-3.5 text-muted-foreground" />
          </button>
        )}
        {!isMinimized && (
          <button
            onClick={(e) => { e.stopPropagation(); onMinimize(); }}
            className="w-7 h-7 rounded hover:bg-secondary flex items-center justify-center"
            title="Minimér"
          >
            <Minus className="w-3.5 h-3.5 text-muted-foreground" />
          </button>
        )}
        <button
          onClick={(e) => { e.stopPropagation(); onClose(); }}
          className="w-7 h-7 rounded hover:bg-secondary flex items-center justify-center"
          title="Luk"
        >
          <X className="w-3.5 h-3.5 text-muted-foreground" />
        </button>
      </div>
    </div>
  );
}
